import {ElsaPurchaseStatus} from '../models/elsa-models';

export const getPurchaseStatus = (integration, purchases) => {
  const purchase = purchases?.filter(p => p.ProductID === integration.id)[0];

  if (purchase === undefined) {
    return null;
  }
  if (purchase?.PurchaseStatus === null) {
    return ElsaPurchaseStatus.Accepted;
  } 
  return purchase?.PurchaseStatus;
}